import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac'
import { SocialMediaConnections } from '@/features/social-media'

export const Route = createFileRoute('/_authenticated/social-media')({
  beforeLoad: async () => {
    const { auth } = useAuthStore.getState()

    // Check if user has admin permissions
    if (!auth.canAccess([PERMISSIONS.SOCIAL_MEDIA.MANAGE])) {
      throw redirect({
        to: '/unauthorized',
      })
    }
  },
  component: SocialMediaConnections,
})
